import { useLayoutEffect } from "react";
import { renderNumberValue } from "utils/string";
const negativeBgWidthRegex = new RegExp("(?:h-)([0-9].*)(?:v)");
const bgWidthRegex = new RegExp("(?:h|h-)([0-9].*)(?:v)");
const useClonePlotClosestLegend = (graphDiv, plotHoverEvent) => {
    useLayoutEffect(() => {
        const mainSVG = graphDiv?.querySelector(".main-svg");
        const hoverlayer = graphDiv?.querySelector(".hoverlayer");
        const hovertext = hoverlayer?.querySelector(".hovertext");
        const clonedTextToRemove = hoverlayer?.querySelector(".clonedText");
        if (plotHoverEvent && hoverlayer && hovertext) {
            clonedTextToRemove && hoverlayer.removeChild(clonedTextToRemove);
            const clonedText = hovertext.cloneNode(true);
            clonedText.classList.replace("hovertext", "clonedText");
            const spike = hoverlayer?.querySelectorAll(".spikeline.crisp")[1];
            const nums = clonedText?.querySelector(".nums");
            const tooltipLines = nums?.querySelectorAll(".line") ?? [];
            const [, xyLine] = tooltipLines;
            if (spike && nums && xyLine) {
                const { points } = plotHoverEvent;
                const { x, y } = points && points[0] ? points[0] : { x: "", y: "" };
                const xValue = renderNumberValue(Number(x));
                const yValue = renderNumberValue(Number(y));
                xyLine.innerHTML = `${xValue}, ${yValue}`;
                hoverlayer.appendChild(clonedText);
                const boundingBox = nums?.getBBox();
                const bg = clonedText.querySelector("path");
                const bgFigure = bg?.getAttribute("d");
                if (boundingBox && bg && bgFigure) {
                    const isBgTransformed = negativeBgWidthRegex.test(bgFigure);
                    bg.setAttribute("d", bgFigure?.replace(bgWidthRegex, `h${isBgTransformed ? "-" : ""}${boundingBox.width + 6}v`));
                    const mainSVGWidth = mainSVG?.getAttribute("width");
                    const spikePosition = spike.getAttribute("x1") || spike.getAttribute("x2") || "";
                    const textTransform = hovertext.getAttribute("transform") || "";
                    const [, yPosition] = textTransform
                        .substring(textTransform.indexOf("(") + 1, textTransform.indexOf(")"))
                        .split(",");
                    if (Number(mainSVGWidth) < Number(spikePosition) + (boundingBox.width + 6)) {
                        clonedText.setAttribute("style", `transform: translate(${Number(spikePosition) - 6}px, ${yPosition}px)`);
                    }
                    else {
                        const isBgTransformed = negativeBgWidthRegex.test(bgFigure);
                        if (isBgTransformed) {
                            bg.setAttribute("transform", "scale(-1)");
                        }
                        nums.setAttribute("text-anchor", "start");
                        tooltipLines.forEach((el) => {
                            el.setAttribute("x", "9");
                        });
                        clonedText.removeAttribute("style");
                    }
                }
                clonedText.classList.add("visible");
            }
        }
        else {
            clonedTextToRemove && hoverlayer?.removeChild(clonedTextToRemove);
        }
    }, [plotHoverEvent, graphDiv]);
};
export default useClonePlotClosestLegend;
